// import React from 'react';
// import { BrowserRouter, Route, Routes } from 'react-router-dom';
// import AuthLayout from './routes/middleware/AuthLayout';
// import NonAuthLayout from './routes/middleware/NonAuthLayout';
// import { authRoutes, nonAuthRoutes, userRoutes } from './routes/AllRoutes';
// import UserLayout from './routes/middleware/UserLayout';
// import AuthProvider from './context/AuthContext';
// import { Toaster } from "react-hot-toast";

// const App = () => {
//   // Renders authenticated routes
//   const renderAuthRoutes = (routes) => {
//     return routes.map((route, idx) => (
//       <Route
//         key={idx}
//         path={route.path}
//         element={
//           <AuthLayout>
//             {route.component}
//           </AuthLayout>
//         }
//       />
//     ));
//   };

//   // Renders non-authenticated routes
//   const renderNonAuthRoutes = (routes) => {
//     return routes.map((route, idx) => (
//       <Route
//         key={idx}
//         path={route.path}
//         element={
//           <NonAuthLayout>
//             {route.component}
//           </NonAuthLayout>
//         }
//       />
//     ));
//   };

//   const renderUserRoutes = (routes) => {
//     return routes.map((route, idx) => (
//       <Route
//         key={idx}
//         path={route.path}
//         element={
//           <UserLayout>
//             {route.component}
//           </UserLayout>
//         }
//       />
//     ));
//   };

//   return (
//     <React.Fragment>
//       <BrowserRouter>
//         <AuthProvider>
//           <div>
//             <Routes>
//               {renderNonAuthRoutes(nonAuthRoutes)}
//               {renderAuthRoutes(authRoutes)}
//               {renderUserRoutes(userRoutes)}
//             </Routes>
//           </div>

         
//           <Toaster position="top-center" reverseOrder={false} />
//         </AuthProvider>
//       </BrowserRouter>
//     </React.Fragment>
//   );
// }

// export default App;


import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import AuthLayout from './routes/middleware/AuthLayout';
import NonAuthLayout from './routes/middleware/NonAuthLayout';
import { authRoutes, nonAuthRoutes, userRoutes } from './routes/AllRoutes';
import UserLayout from './routes/middleware/UserLayout';
import AuthProvider from './context/AuthContext';
import { Toaster } from "react-hot-toast";

const App = () => {
  // Security features - disable right-click, copy, etc.
  // useEffect(() => {
  //   // Disable right-click
  //   const noRightClick = (e) => e.preventDefault();
    
  //   // Disable copy/cut
  //   const noCopy = (e) => e.preventDefault();
    
  //   // Disable keyboard shortcuts
  //   const noKeys = (e) => {
  //     if (
  //       (e.ctrlKey && ['c', 'x', 'a', 'u'].includes(e.key.toLowerCase())) ||
  //       e.key === 'F12' ||
  //       (e.ctrlKey && e.shiftKey && ['i', 'c', 'j'].includes(e.key.toLowerCase()))
  //     ) {
  //       e.preventDefault();
  //     }
  //   };

  //   document.addEventListener('contextmenu', noRightClick);
  //   document.addEventListener('copy', noCopy);
  //   document.addEventListener('cut', noCopy);
  //   document.addEventListener('keydown', noKeys);

  //   return () => {
  //     document.removeEventListener('contextmenu', noRightClick);
  //     document.removeEventListener('copy', noCopy);
  //     document.removeEventListener('cut', noCopy);
  //     document.removeEventListener('keydown', noKeys);
  //   };
  // }, []);

  // Renders authenticated routes
  const renderAuthRoutes = (routes) => {
    return routes.map((route, idx) => (
      <Route
        key={idx}
        path={route.path}
        element={
          <AuthLayout>
            {route.component}
          </AuthLayout>
        }
      />
    ));
  };

  // Renders non-authenticated routes
  const renderNonAuthRoutes = (routes) => {
    return routes.map((route, idx) => (
      <Route
        key={idx}
        path={route.path}
        element={
          <NonAuthLayout>
            {route.component}
          </NonAuthLayout>
        }
      />
    ));
  };

  const renderUserRoutes = (routes) => {
    return routes.map((route, idx) => (
      <Route
        key={idx}
        path={route.path}
        element={
          <UserLayout>
            {route.component}
          </UserLayout>
        }
      />
    ));
  };

  return (
    <HelmetProvider>
      <React.Fragment>
        <BrowserRouter>
          <AuthProvider>
            <div>
              <Routes>
                {renderNonAuthRoutes(nonAuthRoutes)}
                {renderAuthRoutes(authRoutes)}
                {renderUserRoutes(userRoutes)}
              </Routes>
            </div>
            <Toaster position="top-center" reverseOrder={false} />
          </AuthProvider>
        </BrowserRouter>
      </React.Fragment>
    </HelmetProvider>
  );
}

export default App;